import { createContext, useState } from "react";

/**
 * React context for managing global loading state
 * Provides centralized loading state management across the application
 */
export const SelffixLoadingContext = createContext();

/**
 * Selffix loading provider component
 * Manages global loading state and provides loading control functions to child components
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} Provider component with loading context
 */
export const SelffixLoadingProvider = ({ children }) => {

  /** @type {boolean} Global loading state */
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Show global loading indicator
   * @returns {void}
   */
  const showSelffixLoading = () => {
    setIsLoading(true);
  }

  /**
   * Hide global loading indicator
   * @returns {void}
   */
  const closeSelffixLoading = () => {
    setIsLoading(false);
  }

  return <SelffixLoadingContext.Provider value={{ isLoading, showSelffixLoading, closeSelffixLoading }}>{children}</SelffixLoadingContext.Provider>;
};